import React, { Component } from 'react'
import '../../assets/stylesheets/footer.scss'
import '../../assets/stylesheets/footer-grids.scss'
import { StyledFooter } from '../shared-page-components/styled-components.js'

export default class Footer extends Component {
  render() {
    const {
      footerData,
      backgroundColor,
      primaryTextColor,
      secondaryTextColor,
    } = this.props

    return (
      <StyledFooter
        backgroundColor={backgroundColor}
        primaryTextColor={primaryTextColor}
        secondaryTextColor={secondaryTextColor}
        id="contact"
      >
        <div className="grid-row row-1">
          <div className="col-6-12 company-name">
            <div
              className="airlift"
              dangerouslySetInnerHTML={{
                __html: footerData.rowOneLeftColumn.rowOneLeftColumn,
              }}
            />
          </div>
          <div className="col-6-12">
            <div
              className="headquater-address"
              dangerouslySetInnerHTML={{
                __html: footerData.rowOneRightColumn.rowOneRightColumn,
              }}
            />
          </div>
        </div>

        <div className="grid-row row-2">
          <div className="col-6-12 hide-on-mobile-only">
            <div
              className="coordinates"
              dangerouslySetInnerHTML={{
                __html: footerData.rowTwoLeftColumn.rowTwoLeftColumn,
              }}
            />
          </div>
          <div className="col-6-12 ">
            <div
              className="email"
              dangerouslySetInnerHTML={{
                __html: footerData.rowTwoRightColumn.rowTwoRightColumn,
              }}
            />
          </div>
        </div>

        <div className="grid-row row-3">
          <div className="col-6-12 hide-on-mobile-only">
            <div
              className="copyright"
              dangerouslySetInnerHTML={{
                __html: footerData.rowThreeLeftColumn.rowThreeLeftColumn,
              }}
            />
          </div>
          <div className="col-6-12 ">
            <div
              className="social-media"
              dangerouslySetInnerHTML={{
                __html: footerData.rowThreeRightColumn.rowThreeRightColumn,
              }}
            />
          </div>
        </div>

        <div className="grid-row copyright-at-bottom">
          <div className="col-12-12">
            <div
              className="copyright"
              dangerouslySetInnerHTML={{
                __html: footerData.rowThreeLeftColumn.rowThreeLeftColumn,
              }}
            />
          </div>
        </div>
      </StyledFooter>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/footer.js